import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { VariableBenefitAccountDetails } from '../../../../../models/transactions/variable-benefit-account-details';
import { LumpSumPaymentInstruction } from '../../../../../models/transactions/lump-sum-payment-instruction';
import { BaseButtonSizeEnum } from '../../base-button/base-button-size.enum';

@Component({
  selector: 'app-vb-payments-lump-sum-details-card',
  templateUrl: './vb-payments-lump-sum-details-card.component.html',
  styleUrls: ['./vb-payments-lump-sum-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsLumpSumDetailsCardComponent {
  @Input({ required: true }) set accountDetails(value: VariableBenefitAccountDetails) {
    this._accountDetails.next(value);
  }

  @Output() viewPastLumpSumPayments = new EventEmitter<void>();

  private _accountDetails = new BehaviorSubject<VariableBenefitAccountDetails | null>(null);
  public accountDetails$ = this._accountDetails.asObservable();

  public scheduledPayment$: Observable<LumpSumPaymentInstruction | null> = this.accountDetails$.pipe(
    map(details => details?.scheduledLumpSumPaymentInstruction ?? null)
  );

  public hasHistory$: Observable<boolean> = this.accountDetails$.pipe(
    map(details => (details?.historicalLumpSumPayments?.length ?? 0) > 0)
  );

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
